import { AssignmentApplication } from '@/types/models/assignemnt_application';
import { AssignmentApplicationResult } from '@/types/models/assignment_application_result';
import axios from '@/helpers/axios';

export async function applyApplication(id: string, payload: AssignmentApplication) {
  return await axios.post<AssignmentApplicationResult>(`/assignments/${id}/apply`, payload).then(res => res.data);
}
